<div class="dialog-header">
  <h1 mat-dialog-title>
    <span><ng-container i18n>Register Gateway</ng-container></span>
  </h1>
  <p class="instructions">
    <ng-container i18n
      >Fill out the form below to register a Gateway</ng-container
    >
  </p>
</div>

<mat-dialog-content style="padding: 0">
  <form fxLayout="column">
    <div fxFlex fxLayoutGap="1rem">
      <div fxFlex="50%">
        <h4 class="uppercase"><ng-container i18n>Type</ng-container></h4>
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-select
            [formControl]="typeControl"
            [disabled]="loading || response !== null">
            <mat-option value="robustel">NCD Robustel</mat-option>
            <mat-option value="raspberrypi4">Raspberry Pi 4</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </form>
  @if (response) {
    <div fxLayout="column">
      <div fxFlex fxLayoutGap="1rem">
        <div fxFlex="50%">
          <h4 class="uppercase"><ng-container i18n>Name</ng-container></h4>
          <p class="uppercase">{{ response.name }}</p>
        </div>
        <div fxFlex="50%">
          <h4 class="uppercase">
            <ng-container i18n>Balena UUID</ng-container>
          </h4>
          <p>{{ response.uuid }}</p>
        </div>
      </div>
      <div fxFlex fxLayoutGap="1rem">
        <h4 class="uppercase">
          <ng-container i18n>Download Image</ng-container>
        </h4>
        <a [href]="response.configsasuri">{{ response.configsasuri }}</a>
      </div>
      <div fxFlex fxLayoutGap="1rem">
        <h4 class="uppercase"><ng-container i18n>Next Steps</ng-container>:</h4>
        <p>1. <ng-container i18n>Download image file</ng-container></p>
        <p>
          2.
          <ng-container i18n>Flash SD card with downloaded image</ng-container>
        </p>
        <p>
          3. <ng-container i18n>Label Gateway with name and UUID</ng-container>
        </p>
      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  @if (loading) {
    <mat-error style="margin-bottom: 1rem"
      ><ng-container i18n
        >This action may take a while. Please do not close or refresh your
        browser.</ng-container
      ></mat-error
    >
  }
  <section class="buttons uppercase">
    <button
      class="cancel-button"
      [disabled]="loading"
      (click)="dialogRef.close(); typeControl.reset(); response = null">
      @if (!response) {
        <ng-container i18n>Cancel</ng-container>
      }
      @if (response) {
        <ng-container i18n>Close</ng-container>
      }
    </button>
    @if (!response) {
      <button
        class="save-button"
        [disabled]="typeControl.invalid || loading"
        (click)="onSubmit()">
        @if (loading) {
          <img class="loading-spinner" src="assets/img/spin-loader.gif" />
        } @else {
          <ng-container i18n>Register</ng-container>
        }
      </button>
    }
  </section>
</mat-dialog-actions>
